document.addEventListener('click', function (event) {
  var thumb = event.target.closest('[data-vig-gallery-thumb]');
  if (!thumb) return;
  var stage = document.querySelector('[data-vig-gallery-stage]');
  if (!stage) return;
  stage.src = thumb.dataset.src;
  stage.alt = thumb.dataset.alt || '';
  document.querySelectorAll('[data-vig-gallery-thumb]').forEach(function (item) {
    item.setAttribute('aria-selected', item === thumb ? 'true' : 'false');
  });
});

document.addEventListener('change', function (event) {
  var selector = event.target.closest('[data-vig-variant]');
  if (!selector) return;
  var form = selector.closest('form');
  var option = selector.options[selector.selectedIndex];
  var idInput = form && form.querySelector('[data-vig-variant-id]');
  var price = form && form.querySelector('[data-vig-price]');
  if (idInput) idInput.value = selector.value;
  if (price && option) price.textContent = option.dataset.price || price.textContent;
});
